module.exports = __webpack_public_path__ + "img/datacener_pic_qd.52de25e6.jpg";